import { useMemo } from "react";

import { useParams } from "react-router-dom";

export function useSaleRoundRouteParams() {
  const params = useParams();
  const { saleId: saleIdStr, roundId: roundIdStr } = params;

  const saleId = parseInt(saleIdStr, 10);
  const roundId = parseInt(roundIdStr, 10);

  const saleRoundProps = useMemo(
    () => ({ saleId, roundId }),
    [saleId, roundId],
  );

  return { ...params, saleId, roundId, saleRoundProps };
}
